import { ImageCtaCardSection} from "@/design-system/Organisms"; 
import { oralMedImageCtaCardConfig } from "@/design-system/Organisms/ImageCtaCardSection/imageCtaCard.config";
import { OralMedBgSwoopTemplate } from "@/design-system/Templates/OralMedBgSwoopTemplate";

export const OralMedTemplate = () => {
  return (
    <>
      <OralMedBgSwoopTemplate />      
      <ImageCtaCardSection {...oralMedImageCtaCardConfig} />
    </>
  );
};

export default OralMedTemplate;
